import BaseFactory from 'services/sports/default/base-factory';
import Const from 'constants';
import LPClassic from 'services/sports/mma/lp/lp-classic';
import LPShowDown from 'services/sports/mma/lp/lp-showdown';

const classesMap = {
    [Const.GAME_TYPE_CLASSIC]: LPClassic,
    [Const.GAME_TYPE_SHOWDOWN]: LPShowDown,
};

class Factory extends BaseFactory {
    createObj(objectName, params) {
        const {sportConfig} = params;
        const gameType = sportConfig.getGameType();

        if (gameType in classesMap) {
            return new classesMap[gameType](params);
        }

        throw new Error(`Unknown gameType "${gameType}".`);
    }
}

export {Factory};
